import { useTranslation } from 'react-i18next';
import { BaseModal, BaseModalProps } from '@anytag/shared-atoms';
import { CustomDownloadType, DownloadFileType } from '@anytag/shared-types';

export interface GoogleAuthDialogProps extends Pick<BaseModalProps, 'open' | 'onClose'> {
  authType?: DownloadFileType | CustomDownloadType;
  onAuthenticate: () => void;
}

export const GoogleAuthDialog = ({ open, onClose, authType, onAuthenticate }: GoogleAuthDialogProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('Login Google Account')}
      description={t(
        authType === DownloadFileType.GOOGLE_SLIDE
          ? 'Please authenticate with Google to export to Google Slides'
          : authType === DownloadFileType.SPREADSHEET
            ? 'Please authenticate with Google to export to Google Sheets'
            : 'Please authenticate with Google to export to Google Docs'
      )}
      footer={{
        cancelButton: { onClick: onClose },
        submitButton: { onClick: onAuthenticate, title: t('Button.Authenticate with Google') }
      }}
    />
  );
};
